import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateHandoverByIdMutationVariables = Types.Exact<{
  set?: Types.InputMaybe<Types.Handover_Set_Input>;
  id: Types.Scalars['uuid']['input'];
}>;


export type UpdateHandoverByIdMutation = { __typename?: 'mutation_root', update_handover_by_pk?: { __typename?: 'handover', id: any, project_name: string, project_description?: string | null, status: string, vendor_device_notes?: string | null, requester_notes?: string | null, created_at?: any | null, updated_at?: any | null, published_at?: any | null, public_data_snapshot?: any | null, vendor_organization_id?: any | null, customer_organization_id?: any | null, property_id?: any | null, created_by_user_id: string, vendor_organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, customer_organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null, property?: { __typename?: 'properties', id: any, name: string, address?: string | null, address_id?: any | null, organization_id: any, standardized_address?: { __typename?: 'addresses', id: any, street_1: string, street_2?: string | null, city: string, state: string, postal_code: string, country: string } | null } | null, requester?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null, organization?: { __typename?: 'organizations', id: any, name: string, email?: string | null, type?: string | null, organizationImageURL?: string | null } | null } | null, guides: Array<{ __typename?: 'guides', id: any, handover_id?: any | null, updated_at: any, title?: string | null, status: string, description?: string | null, video_url?: string | null, thumbnail_url?: string | null, thumbnail_timestamp_ms?: any | null, created_by_user_id?: string | null, organization_id?: any | null, guide_steps: Array<{ __typename?: 'guide_steps', id: any, title: string, body?: string | null, image_url?: string | null, video_url?: string | null }>, product_guides: Array<{ __typename?: 'product_guides', id: any, product?: { __typename?: 'products', id: any, photo_link?: string | null, installed_products: Array<{ __typename?: 'installed_products', id: any, property_id: any, photo_link?: string | null }>, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null }> } | null }> }>, property_documents: Array<{ __typename?: 'property_documents', id: any, property_id: any, name?: string | null, mime_type?: string | null, document_link?: string | null, photo_link?: string | null, video_link?: string | null, handover_id?: any | null }>, device_detection_jobs: Array<{ __typename?: 'device_detection_jobs', id: any, workspace_id?: any | null, status: string, input_files?: any | null, ai_response?: any | null, detected_devices?: any | null, detected_installed_products?: any | null, products_grouped_by_type?: any | null, handover_id?: any | null, created_at?: any | null, updated_at: any, property_id: any, organization_id?: any | null, created_by_user_id?: string | null, property: { __typename?: 'properties', id: any, name: string, address?: string | null, photo_link?: string | null }, organization?: { __typename?: 'organizations', id: any, name: string, type?: string | null, organizationImageURL?: string | null } | null, author?: { __typename?: 'users', first_name: string, last_name: string, email: string } | null }>, user_invitations: Array<{ __typename?: 'user_invitations', id: any, email: string, role?: string | null, status: string, message?: string | null, properties_ids?: Array<string> | null, organization_id?: any | null, sender_id?: string | null, handover_id?: any | null, sender?: { __typename?: 'users', id: string, first_name: string, last_name: string, role?: string | null, email: string, organization_id?: any | null } | null }>, installed_products: Array<{ __typename?: 'installed_products', id: any, product_id: any, property_id: any, installation_date: any, warranty_expiration_date?: any | null, warranty_status: string, product_serial?: string | null, product_notes?: string | null, photo_link?: string | null, location?: string | null, partition_id?: string | null, property?: { __typename?: 'properties', id: any, name: string, partition_id?: string | null } | null, installed_product_attachments: Array<{ __typename?: 'installed_product_attachments', id: any, installed_product_id: any, name?: string | null, type?: string | null, mime_type?: string | null, description?: string | null, photo_link?: string | null, video_link?: string | null, document_link?: string | null, audio_link?: string | null, site_link?: string | null }>, product: { __typename?: 'products', id: any, name: string, description: string, sku?: string | null, make: string, model: string, retail_price?: any | null, extended_price?: any | null, product_notes?: string | null, workspace_id?: any | null, organization_id?: any | null, photo_link?: string | null, parent_product_id?: any | null, partition_id?: string | null, handover_id?: any | null, product_category: { __typename?: 'product_categories', name: string, label: string }, product_attachments: Array<{ __typename?: 'product_attachments', id: any, photo_link?: string | null, document_link?: string | null, video_link?: string | null, audio_link?: string | null, site_link?: string | null, transcription?: string | null, transcribed: boolean, type?: string | null, description?: string | null, name?: string | null }> } }> } | null };


export const UpdateHandoverByIdDocument = gql`
    mutation updateHandoverById($set: handover_set_input, $id: uuid!) {
  update_handover_by_pk(_set: $set, pk_columns: {id: $id}) {
    id
    project_name
    project_description
    status
    vendor_device_notes
    requester_notes
    created_at
    updated_at
    published_at
    public_data_snapshot
    vendor_organization_id
    vendor_organization {
      id
      name
      email
      type
      organizationImageURL
    }
    customer_organization_id
    customer_organization {
      id
      name
      email
      type
      organizationImageURL
    }
    property_id
    property {
      id
      name
      address
      address_id
      standardized_address {
        id
        street_1
        street_2
        city
        state
        postal_code
        country
      }
      organization_id
    }
    created_by_user_id
    requester {
      id
      first_name
      last_name
      role
      email
      organization_id
      organization {
        id
        name
        email
        type
        organizationImageURL
      }
    }
    guides {
      id
      handover_id
      updated_at
      title
      status
      description
      video_url
      thumbnail_url
      thumbnail_timestamp_ms
      guide_steps {
        id
        title
        body
        image_url
        video_url
      }
      product_guides {
        id
        product {
          id
          photo_link
          installed_products(distinct_on: property_id) {
            id
            property_id
            photo_link
          }
          product_attachments {
            id
            photo_link
          }
        }
      }
      created_by_user_id
      organization_id
    }
    property_documents {
      id
      property_id
      name
      mime_type
      document_link
      photo_link
      video_link
      handover_id
    }
    device_detection_jobs {
      id
      workspace_id
      status
      input_files
      ai_response
      detected_devices
      detected_installed_products
      products_grouped_by_type
      handover_id
      created_at
      updated_at
      property_id
      property {
        id
        name
        address
        photo_link
      }
      organization_id
      organization {
        id
        name
        type
        organizationImageURL
      }
      created_by_user_id
      author {
        first_name
        last_name
        email
      }
    }
    user_invitations {
      id
      email
      role
      status
      message
      properties_ids
      organization_id
      sender_id
      sender {
        id
        first_name
        last_name
        role
        email
        organization_id
      }
      handover_id
    }
    installed_products {
      id
      product_id
      property_id
      installation_date
      warranty_expiration_date
      warranty_status
      product_serial
      product_notes
      photo_link
      location
      partition_id
      property {
        id
        name
        partition_id
      }
      installed_product_attachments {
        id
        installed_product_id
        name
        type
        mime_type
        description
        photo_link
        video_link
        document_link
        audio_link
        site_link
      }
      product {
        id
        name
        description
        sku
        product_category {
          name
          label
        }
        make
        model
        retail_price
        extended_price
        product_notes
        workspace_id
        organization_id
        photo_link
        parent_product_id
        partition_id
        handover_id
        product_attachments(order_by: {created_at: asc}) {
          id
          photo_link
          document_link
          video_link
          audio_link
          site_link
          transcription
          transcribed
          type
          description
          name
        }
      }
    }
  }
}
    `;
export type UpdateHandoverByIdMutationFn = Apollo.MutationFunction<UpdateHandoverByIdMutation, UpdateHandoverByIdMutationVariables>;

/**
 * __useUpdateHandoverByIdMutation__
 *
 * To run a mutation, you first call `useUpdateHandoverByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHandoverByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHandoverByIdMutation, { data, loading, error }] = useUpdateHandoverByIdMutation({
 *   variables: {
 *      set: // value for 'set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateHandoverByIdMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHandoverByIdMutation, UpdateHandoverByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHandoverByIdMutation, UpdateHandoverByIdMutationVariables>(UpdateHandoverByIdDocument, options);
      }
export type UpdateHandoverByIdMutationHookResult = ReturnType<typeof useUpdateHandoverByIdMutation>;
export type UpdateHandoverByIdMutationResult = Apollo.MutationResult<UpdateHandoverByIdMutation>;
export type UpdateHandoverByIdMutationOptions = Apollo.BaseMutationOptions<UpdateHandoverByIdMutation, UpdateHandoverByIdMutationVariables>;